module.exports = __webpack_public_path__ + "img/weapons.accaf6fc.png";